import { LayoutDashboard, Users, Building2, Tags, Car, Activity, FileText, ScrollText, CalendarCheck } from "lucide-react";

export const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/employees", label: "Employees", icon: Users },
  { to: "/admin/schedules", label: "Schedules", icon: CalendarCheck },
  { to: "/admin/dealerships", label: "Dealerships", icon: Building2 },
  { to: "/admin/dealership-tags", label: "Dealership Tags", icon: Tags },
  { to: "/admin/customer-inspections", label: "Customer Cars", icon: Car },
  { to: "/admin/logs", label: "Activity Logs", icon: Activity },
  { to: "/admin/reports", label: "Weekly Reports", icon: FileText },
  { to: "/admin/sops", label: "SOPs & Policy", icon: ScrollText },
];
